<div class="card">
  <div class="area-card-header">
    <div class="title-icon">
      <ng-content select="[card-title-icon]"></ng-content>
    </div>
    <div class="title-content">
      <ng-content select="[card-title-content]"></ng-content>
    </div>
  </div>
  <div class="area-card-content">
    <ng-content select="[card-content]"></ng-content>
  </div>
</div>
